import axios from 'axios'

const lawyer = {}
// 删除课律师
lawyer.del = params => { return axios.post('/lawyer/del', params) }
// 加载律师
lawyer.load = params => { return axios.get('/lawyer/load', {params}) }
// 保存律师
lawyer.save = params => { return axios.post('/lawyer/update', params) }
// 查询律师
lawyer.find = params => { return axios.get('/lawyer/find', {params}) }
// 导入律师
lawyer.uploadLawyer = params => { return axios.post('/lawyer/uploadLawyer', params) }
// 锁定律师
lawyer.locking = params => { return axios.post('/lawyer/locking', params) }
// 审核律师
lawyer.registrationAudit = params => { return axios.post('/lawyer/registrationAudit', params) }
// 律师执业证书编号是否重复
lawyer.repear = params => { return axios.get('/lawyer/repear', {params}) }
// 重置密码
lawyer.resetPwd = params => { return axios.get('/lawyer/resetPwd', {params}) }
export default lawyer



// WEBPACK FOOTER //
// ./src/api/lawyer.js